<app-login-layout>
  <div class="mainContent">
    <div>
      <h2>{{ trans('auth.labels.checkEmail') }}</h2>
      <p>{{ trans('auth.labels.checkEmailPrompt').replace('%email%', login.email) }}</p>
    </div>
  </div>
</app-login-layout>
